import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import moment from "moment";
import { days_ago } from 'src/utils/CommonUtils';

const CombinedTaskCard = ({ task, handleMarkAsCompleted, handleSkipTask, onDelete,onEdit }) => {
  const {
    search: { data = [] } = {},
  } = useSelector((state) => state.ScheduleTaskReducer, shallowEqual);
  // console.log("task.isPending", task.isPending);
  const backgroundColor =task.isPending ? '#FFC107' :
    task.type === 'Hierarchy' ? '#E9F2FF' :
      task.type === 'Fixed' ? '#F3FFF8' :
        '#FFFFFF';
  // const backgroundGradient =
  //   task.type === 'Hierarchy'
  //     ? 'linear-gradient(135deg, #E9F2FF 0%, #D6E6FF 100%)'
  //     : task.type === 'Fixed'
  //     ? 'linear-gradient(135deg, #F3FFF8 0%, #D1F2E5 100%)'
  //     : '#FFFFFF';  

  const textColor =
    task.type === 'Hierarchy'
      ? '#004085'
      : task.type === 'Fixed'
        ? '#155724'
        : '#212529';

  const buttonClass =
    task.type === 'Hierarchy'
      ? 'btn-outline-primary'
      : task.type === 'Fixed'
        ? 'btn-outline-success'
        : 'btn-outline-secondary';
const handleOnEdit = (EditTask) => {
  const taskData = data.find(t => t._id === EditTask.subTaskId);
  onEdit(data,taskData);
}
  return (
    <div className="card card border shadow-none border-dark mb-3 rounded-3" style={{ backgroundColor }}>
      <div className="card-body d-flex justify-content-between align-items-center">
        <div className="d-grid flex-column flex-md-row w-100" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '7px 40px' }}>
          <div className='font-14 d-flex gap-2'><strong>Project:</strong> {task.task}</div>
          {/* <div className='font-14 d-flex gap-2'><strong>Task:</strong> {task.subtask}</div> */}
        <div className="font-14 d-flex gap-2" style={{ alignItems: "center" }}>
  <strong>Task:</strong>

  <span className="subtask-wrapper">
    <span className="subtask-text">{task.subtask}</span>
    <span className="custom-tooltip">{task.subtask}</span>
  </span>
</div>



          <div className='font-14 d-flex gap-2'><strong>Created At:</strong> {moment(task.ts).format("DD-MM-YYYY hh:mm A")}</div>
          <div className='font-14 d-flex gap-2'><strong>Pending Since:</strong> {days_ago(task.ts)}</div>
          <div className='font-14 d-flex gap-2'><strong>Assigned to:</strong> {task.assignedTo} {task.assignedTo === 'Other' && `(${task.assignedUser})`}</div>
          <div className='font-14 d-flex gap-2'><strong>Frequency:</strong> {task.frequency}</div>
          {/* <div className='font-14 d-flex gap-2'><strong>Day:</strong> {task.frequency}</div> */}
          {/* {task.duration && <div className='font-14 d-flex gap-2'><strong>Duration:</strong> {task.duration}</div>} */}
          {task.startTime&&task.startTime!=="N/A" && <div className='font-14 d-flex gap-2'><strong>Start Time:</strong> {task.startTime}</div>}
        </div>
        <button className={`btn ${buttonClass}`} style={{ fontSize: '14px', minWidth: '170px' }} onClick={() => { handleMarkAsCompleted(task.subTaskId) }}>Mark as Completed</button>
        <button className={`btn mt-1 `} style={{ fontSize: '14px', minWidth: '170px' }} onClick={() => { handleSkipTask(task.subTaskId) }}>Skip</button>
        <button className="px-10 py-4 border-0 me-1 text-primary" onClick={() => handleOnEdit(task)}>
                  <i className="mdi mdi-border-color mdi-24px"></i>
                </button>
        <button
          className="px-10 py-4 border-0 text-danger"
          onClick={() => onDelete(task)}
        >
          <i className="mdi mdi-delete mdi-24px"></i>
        </button>
      </div>
    </div>
  );
};

export default CombinedTaskCard;
